<template>
  <div>
    <section class="content-header">
      <h1>{{ $t('company.edit', {entity: retrieved && retrieved.name}) }}</h1>
    </section>

    <item-update-errors :entity="'company'" :is-loading="isLoading"></item-update-errors>

    <CompanyForm
      v-if="item && !isLoading"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CompanyForm from './Form.vue'
import ItemUpdateErrors from '../layout/errors/ItemUpdateErrors'

export default {
  components: {
    ItemUpdateErrors,
    CompanyForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'company/update/isLoading',
      deleted: 'company/del/deleted',
      retrieved: 'company/update/retrieved',
      violations: 'company/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'CompanyList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'company/create/reset',
      delReset: 'company/del/reset',
      retrieve: 'company/update/retrieve',
      updateReset: 'company/update/reset',
      update: 'company/update/update',
      updateRetrieved: 'company/update/updateRetrieved'
    }),

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update().then(item => {
        this.$router.push({name: 'CompanyShow', params: {id: item['@id']}})
      }).catch(e => {})
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/Update.vue